import React from 'react'
import PropTypes from 'prop-types'
import styled from '@emotion/styled'

import { TYPOGRAPHY_21_500 } from 'theme/theme'

const StyledSub = styled.div`
  ${TYPOGRAPHY_21_500}

  color: #646770;
`

const SubTitle = ({ t, className }) => (
  <StyledSub className={className}>
    { t }
  </StyledSub>
)

export default SubTitle

SubTitle.propTypes = {
  t: PropTypes.string,
  className: PropTypes.any
}
